import { render, staticRenderFns } from "./clinicalSetting.vue?vue&type=template&id=4acbf5aa&scoped=true"
import script from "./clinicalSetting.vue?vue&type=script&lang=js"
export * from "./clinicalSetting.vue?vue&type=script&lang=js"
import style0 from "./clinicalSetting.vue?vue&type=style&index=0&id=4acbf5aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acbf5aa",
  null
  
)

export default component.exports